'use client';

import { c as _c } from "react/compiler-runtime";
import { renewPushSubscriptionOnStaleKey } from '@/utils/push-notifications/push-subscription';
import { useEffect } from 'react';

/**
 * Checks once per page load whether this browser's push subscription still uses the current
 * VAPID key, and moves it over if not.
 */
export const usePushSubscriptionKeyRenewal = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp2, t0);
};
function _temp(error) {
  console.warn("Failed to move the push subscription to the current VAPID key", error);
}
function _temp2() {
  renewPushSubscriptionOnStaleKey().catch(_temp);
}